import VPageCardUpdateRecord from './index.vue';

export default {
  install: (Vue) => Vue.component('VPageCardUpdateRecord', VPageCardUpdateRecord),
};
